import { z } from 'zod';

/**
 * @aiPurpose response envelope for `GET /api/leads/assignable-managers`.
 * @aiSecurity exposes only the identity fields needed by the manual-assignment
 *   picker; role, duty, contact, and account-state fields stay server-side.
 */
export const LeadAssignableManagersResponseSchema = z
  .object({
    managers: z.array(
      z
        .object({
          id: z.string().uuid(),
          name: z.string().min(1),
        })
        .strict(),
    ),
  })
  .strict();

export type LeadAssignableManagersResponse = z.infer<typeof LeadAssignableManagersResponseSchema>;
